var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},_vm._l((_vm.number),function(item){return _c('div',{key:item,staticClass:"arrowItem",style:('margin-bottom:'+_vm.margin+'rem')},[_c('div',{staticClass:"arrow"}),_c('div',{staticClass:"arrow"}),_c('div',{staticClass:"arrow"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }